class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
  }

  // Click-based dropdown: das native <summary> toggelt das Menü auf Klick.
  // Maus-bedingten Fokusverlust ignorieren (sonst schliesst es beim Bewegen zum
  // Panel). Geschlossen wird nur durch Klick ausserhalb, Escape oder erneuten
  // Klick auf den Trigger.
  onFocusOut() {}

  onToggle() {
    // Nur Desktop: das Inline-Dropdown existiert <990px nicht (display:none),
    // dort übernimmt der Burger-Drawer (eigene Komponente) komplett.
    if (this.mainDetailsToggle.open && window.matchMedia('(min-width: 990px)').matches) {
      // toggle feuert asynchron nach dem Öffnungsklick → kein Sofort-Schliessen.
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onDocumentKeydown);
    } else {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onDocumentKeydown);
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  onDocumentKeydown(event) {
    if (event.key !== 'Escape') return;
    this.close();
    this.mainDetailsToggle.querySelector('summary').focus();
  }
}

customElements.define('header-menu', HeaderMenu);
